var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.posts, function (post) {
        return _c(
          "a",
          {
            key: post.id,
            staticClass: "article-member",
            attrs: { href: post.postUrl },
          },
          [
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "d-flex iconTitle" }, [
                _c("i", { staticClass: "type Artículos" }),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "kicker" }, [
                    _vm._v(
                      "\n            " + _vm._s(post.header) + "\n            "
                    ),
                    _c("span", { staticClass: "date" }, [
                      _vm._v(_vm._s(_vm.formatDate(post.create))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "title",
                    domProps: { innerHTML: _vm._s(post.title) },
                  }),
                ]),
              ]),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.nextPageEnabled
        ? _c("div", { staticClass: "title-section defaultSect" }, [
            _c("h3", { staticClass: "heading-title-sect text-center" }, [
              _c("a", { on: { click: _vm.nextPage } }, [
                _c("span", [_vm._v("VER MÁS")]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }